import * as React from 'react';
import { Avatar } from '@mui/material';
import { styled } from '@mui/material/styles';
import { serviceLocator } from '../services/service-locator';
import { withSnackbar, WithSnackbarProps } from './withSnackbar';
import axios from 'axios';

const authenticationService = serviceLocator.getAuthenticationService();

const ImgPreview = styled('img')({
  width: '100%',
  height: '100%',
  maxWidth: '300px',
  maxHeight: '300px',
});

export interface AgencyLogoState {
  selectedFile: any;
}

interface AgencyLogoProps extends WithSnackbarProps {
  avatar?: boolean;
}

const noImage = "https://trusteid.mioa.gov.mk/wp-content/plugins/uix-page-builder/uixpb_templates/images/UixPageBuilderTmpl/no-logo.png";

export class AgencyLogoInner extends React.Component<AgencyLogoProps, AgencyLogoState>{

  constructor(props: AgencyLogoProps) {
    super(props);
    this.state = {
      selectedFile: noImage,
    };
  }

  componentDidMount() {
    this.getLogo()
  }

  getLogo = async () => {
    const authUserData = authenticationService.getAuthenticatedUserData();
    const response = await axios.get(`/api/agencies/${authUserData?.ownedAgency}/logo/`);
    console.log('response', response)
    if (response.data?.success == false) {
      this.setState({
        selectedFile: noImage
      });
    } else {
      this.setState({
        selectedFile: "data:image\/png;base64, " + response.data
      });
    }
  }

  public render() {
    const authUserData = authenticationService.getAuthenticatedUserData();


    return (
      this.props.avatar ?
        <Avatar src={this.state.selectedFile} alt={authUserData?.ownedAgency} />
        :
        <ImgPreview src={this.state.selectedFile} alt={authUserData?.ownedAgency} />
    );
  }
}

export const AgencyLogo = withSnackbar(AgencyLogoInner);
